import { Button, Tooltip } from 'antd';
import { SyncOutlined } from '@ant-design/icons';

interface Props {
  tooltip: string;
  onClick: () => void;
  disabled?: boolean;
}

export function SyncIconButton({ tooltip, onClick, disabled }: Props) {
  return (
    <Tooltip title={tooltip}>
      <Button
        type="text"
        size="small"
        icon={<SyncOutlined style={{ fontSize: 12 }} />}
        onClick={onClick}
        disabled={disabled}
        style={{ padding: 0, height: 20, width: 20 }}
      />
    </Tooltip>
  );
}
